<button
    *ngIf="texts$ | async as text"
    tuiIconButton
    type="button"
    size="s"
    icon="tuiIconSpoilerLarge"
    appearance="icon"
    tuiHintDirection="top-left"
    tuiHintDescribe
    [tuiHint]="text.setDetails"
    [focusable]="false"
    (click)="setDetails()"
></button>
